import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-compliance',
  standalone: false,
  templateUrl: './compliance.component.html',
  styleUrls: ['./compliance.component.scss']
})
export class ComplianceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
